module.exports = __webpack_public_path__ + "img/asuka_ginojishusei.9b34a274.jpg";